import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
import "./Picture.scss";

import { useMediaQuery } from "react-responsive";

const Picture = ({ hit }) => {
    const isBigScreen = useMediaQuery({ query: "(min-width: 1280px)" });
    const isDesktop = useMediaQuery({
        query: "(min-width: 1024px) and (max-width: 1279px)",
    });
    const isTablet = useMediaQuery({
        query: "(min-width: 768px) and  (max-width: 1023px)",
    });
    const isMobileBig = useMediaQuery({
        query: "(min-width: 480px) and (max-width: 767px)",
    });
    const isMobile = useMediaQuery({
        query: "(min-width: 320px) and (max-width: 479px)",
    });

    return (
        <picture className="search-hit__picture">
            {Object.keys(hit.imageUrls).map((element, key) => {
                return (
                    <source
                        key={key}
                        srcSet={hit.imageUrls[element]}
                        type="image"
                        className=""
                    ></source>
                );
            })}
            {isBigScreen ? (
                <LazyLoadImage
                    effect="opacity"
                    src={hit.imageUrls["800x800"]}
                    width="100%"
                    title={hit.name}
                    alt=""
                />
            ) : null}
            {isDesktop ? (
                <LazyLoadImage
                    effect="opacity"
                    src={hit.imageUrls["800x800"]}
                    width="100%"
                    title={hit.name}
                    alt=""
                />
            ) : null}

            {isTablet ? (
                <LazyLoadImage
                    effect="opacity"
                    src={hit.imageUrls["600x600"]}
                    width="600px"
                    title={hit.name}
                    alt=""
                />
            ) : null}
            {isMobileBig ? (
                <LazyLoadImage
                    effect="opacity"
                    src={hit.imageUrls["800x800"]}
                    width="100%"
                    title={hit.name}
                    alt=""
                />
            ) : null}
            {isMobile ? (
                <LazyLoadImage
                    effect="opacity"
                    src={hit.imageUrls["600x600"]}
                    width="100%"
                    title={hit.name}
                    alt=""
                />
            ) : null}
        </picture>
    );
};

export default Picture;
